import { Stack, Text, Button, ThemeIcon } from "@mantine/core";
import { IconDatabaseOff } from "@tabler/icons-react";

interface EmptyStateAction {
  label: string;
  onClick?: () => void;
  href?: string;
}

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: EmptyStateAction;
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <Stack align="center" gap="md" py="xl">
      <ThemeIcon variant="light" size={60} radius="xl" color="gray">
        {icon ?? <IconDatabaseOff size={30} />}
      </ThemeIcon>
      <Stack align="center" gap={4}>
        <Text fw={500} size="lg">
          {title}
        </Text>
        {description && (
          <Text c="dimmed" size="sm" ta="center" maw={400}>
            {description}
          </Text>
        )}
      </Stack>
      {action && (
        action.href ? (
          <Button component="a" href={action.href} variant="light">
            {action.label}
          </Button>
        ) : (
          <Button variant="light" onClick={action.onClick}>
            {action.label}
          </Button>
        )
      )}
    </Stack>
  );
}
